import { ApplicationRef, ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter } from 'rxjs/operators';

import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationComponent } from '@core/layout/navigation/navigation.component';
import { InjectorLocatorService } from '@app/injector-locator.service';

@Component({
  selector: 'tess-app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NavigationComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly #router = inject(Router);
  readonly #applicationRef = inject(ApplicationRef);

  readonly #routerEvents = toSignal<NavigationEnd>(
    this.#router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)),
  );

  readonly showNavigation = computed(() => {
    const event = this.#routerEvents();
    return !!event && !event.urlAfterRedirects.includes('builder');
  });

  constructor() {
    InjectorLocatorService.injector = this.#applicationRef.injector;
  }
}
